export default __webpack_public_path__ + "static/media/layout1.b52562f7.svg";